<template>
  <div class="dialog-container">
    <div class="dialog-mask" @click="cancel"></div>
    <div class="dialog-content">
      <div class="content">
        <div class="content-title">
          <span>组织架构模板</span>
          <i class="el-icon-close close-icon" @click="cancel"></i>
        </div>
        <div class="content-body">
          <div>
            <el-form
              label-position="left"
              label-width="12vw"
              :model="formData"
              :rules="formRules"
              ref="uploadForm"
              class="custom-form-layout"
            >
              <el-form-item label="下载模板:" class="form-item-custom">
                <el-button
                  class="filter-item"
                  size="mini"
                  type="primary"
                  icon="el-icon-download"
                  @click="downloadExcel()"
                  >下载模板</el-button
                >
              </el-form-item>
              <el-form-item
                label="选择导入文件:"
                prop="file"
                class="form-item-custom"
              >
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx"
                  :action="uploadUrl"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  :file-list="fileList"
                >
                  <el-button slot="trigger" size="small" type="primary"
                    >选择文件</el-button
                  >
                  <div
                    slot="tip"
                    class="el-upload__tip"
                    style="display: inline-block; margin-left: 20px"
                  >
                    只能上传xlsx、xls文件
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="content-foot">
          <el-button @click="cancel" size="small">取消</el-button>
          <el-button type="primary" @click="handleUploadFile" size="small"
            >上传</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrganizationImport",
  data() {
    return {
      formData: {
        file: null,
      },
      formRules: {
        file: [
          { required: true, message: "请选择导入文件", trigger: "change" },
        ],
      },
      fileList: [],
      uploadUrl: "/importUsers",
    };
  },
  methods: {
    downloadExcel() {
      // 下载模板逻辑
      const link = document.createElement("a");
      link.href = "./static/organization_template.xlsx";
      link.download = "组织导入模板.xlsx";
      link.click();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleChange(file, fileList) {
      this.formData.file = file;
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.formData.file = null;
    },
    UploadUrl() {
      return this.uploadUrl;
    },
    // handleUploadFile() {
    //   this.$refs.uploadForm.validate((valid) => {
    //     if (valid) {
    //       if (this.fileList.length === 0) {
    //         this.$message.error('请选择要上传的文件')
    //         return
    //       }
    //
    //       this.$refs.upload.submit()
    //       this.$message.success('文件上传成功')
    //       this.$emit('success')
    //       this.cancel()
    //     } else {
    //       this.$message.error('请完善表单信息')
    //     }
    //   })
    // },
    async handleUploadFile() {
      try {
        // 表单验证
        const valid = await this.$refs.uploadForm.validate();
        if (!valid) {
          this.$message.error("请完善表单信息");
          return;
        }

        // 文件存在性检查
        if (this.fileList.length === 0) {
          this.$message.error("请选择要上传的文件");
          return;
        }

        this.uploading = true;
        console.log("=== 开始文件上传 ===");
        console.log("上传文件:", this.formData.file);

        // 执行上传
        const result = await this.performUpload();

        console.log("=== 最终上传结果 ===");
        console.log("结果数据:", result);

        // 统一处理服务端响应格式
        if (result && result.success) {
          this.$message.success(result.message || "文件上传成功");
          this.$emit("success", result.data);
          this.cancel();
        } else {
          this.$message.error(result.message || "上传失败，请稍后重试");
        }
      } catch (error) {
        console.error("上传验证失败:", error);
        this.$message.error("表单验证失败");
      } finally {
        this.uploading = false;
      }
    },
    async performUpload() {
      // 先进行文件验证
      if (!this.formData.file || !this.formData.file.raw) {
        console.error("文件不存在或格式不正确");
        return {
          success: false,
          code: -1,
          message: "文件不存在或格式不正确",
        };
      } else {
        const formData = new FormData();
        formData.append("file", this.formData.file.raw);

        try {
          const response = await this.$http.post(this.uploadUrl, formData, {
            timeout: 30000,
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                console.log(`上传进度: ${percent}%`);
              }
            },
          });

          // 统一响应格式处理
          const serverData = response.data;
          return {
            success: serverData.code === 0 || serverData.success === true,
            code: serverData.code || 0,
            message: serverData.message || "上传成功",
            data: serverData.data || serverData,
          };
        } catch (error) {
          console.error("=== 自定义上传错误详情 ===");
          console.error("错误信息:", error.message);
          console.error(
            "错误响应数据:",
            error.response ? error.response.data : ""
          );
          console.error(
            "错误状态码:",
            error.response ? error.response.status : ""
          );

          // 统一错误响应格式
          const errorResponse = error.response ? error.response.data : null;
          return {
            success: false,
            code: error.response ? error.response.status : -1,
            message: errorResponse
              ? errorResponse.message
              : "上传失败，请稍后重试",
            data: errorResponse,
          };
        }
      }
    },

    cancel() {
      this.$emit("close");
    },
  },
  mounted() {
    // 阻止背景滚动
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    // 恢复背景滚动
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 500px;
  max-width: 600px;
}

.content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
}

.content-title span {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.custom-form-layout {
  margin: 0 auto;
  padding: 20px 30px;
}

.form-item-custom {
  margin-bottom: 20px;
}

.form-item-custom :deep(.el-form-item__label) {
  text-align: left;
  padding-right: 15px;
  font-weight: 500;
}
.close-icon {
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.close-icon:hover {
  color: #409eff;
}

.content-body {
  flex: 1;
  padding: 20px;
}

.content-foot {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
  background: #f5f7fa;
}

.content-foot .el-button {
  min-width: 80px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dialog-content {
    min-width: 90%;
    max-width: 90%;
  }

  .content-body {
    padding: 15px;
  }

  .el-form-item {
    margin-bottom: 18px;
  }
}
</style>
